<h2 mat-dialog-title>Set starting view</h2>
<mat-dialog-content class="picker-content">
  <div class="picker-hint">
    Navigate inside the home to the exact spot a prospect should land on. Click <strong>Capture this view</strong> to save the current panorama and viewing angle as the starting view for this reel item.
  </div>

  <div class="model-container" #modelContainer>
    <situ-view-readonly
      [routeParams]="routeParams"
      [style.width.px]="viewerWidth"
      [style.height.px]="viewerHeight">
    </situ-view-readonly>
  </div>

  <div class="paste-row">
    <mat-form-field appearance="outline" class="paste-field">
      <mat-label>Or paste a "share this location" URL</mat-label>
      <input matInput [(ngModel)]="pastedUrl"
             placeholder="https://portal.situflow.com/&lt;id&gt;?panorama=...&hlookat=...&vlookat=..."
             (keydown.enter)="applyPastedUrl()">
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="applyPastedUrl()" [disabled]="!pastedUrl">
      <mat-icon>link</mat-icon>
      Load
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="clearOverride()" color="warn"
          *ngIf="data.currentStartViewQuery">
    <mat-icon>delete_outline</mat-icon>
    Clear override
  </button>
  <span class="spacer"></span>
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="captureCurrentView()">
    <mat-icon>my_location</mat-icon>
    Capture this view
  </button>
</mat-dialog-actions>
